export { Modal } from "./Modal";
export type { ModalProps } from "./Modal";

export { default as ModalWrapper } from "./ModalWrapper";
